import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { SURVEY_TYPE } from "./config";

const requestSchema = yup.object({
  hash: yup.string().required(),
  patientId: yup.number().required(),
  accountId: yup.number().required(),
  answers: yup
    .array()
    .of(
      yup.object({
        questionId: yup.number().required(),
        questionType: yup.string().required(),
        questionText: yup.string().required(),
        answers: yup.array().of(yup.string()).required(),
        comment: yup.string().nullable(),
      }),
    )
    .required(),
});

export function usePublicSurveySaveMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return await http.post(HTTP_ENDPOINTS.surveys.public.save(), {
        url_key: req.hash,
        patient_id: req.patientId,
        account_id: req.accountId,
        questions: req.answers.map((answer) => ({
          question_id: answer.questionId,
          quest_type: answer.questionType,
          quest_text: answer.questionText,
          answers:
            answer.questionType === SURVEY_TYPE.scale
              ? [answer.answers[0] || "", answer.comment || ""]
              : answer.answers,
        })),
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.surveys.public],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
